var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('StandappHeaderV2Component'),_vm._t("default"),(['shome'].includes(_vm.$route.name))?_c('AuthFooterV2Component'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }